/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseListPendingMessageResponse } from '../../models/api-response-list-pending-message-response';

export interface ResendBulkPendingMessages$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
      body: Array<string>
}

export function resendBulkPendingMessages(http: HttpClient, rootUrl: string, params: ResendBulkPendingMessages$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListPendingMessageResponse>> {
  const rb = new RequestBuilder(rootUrl, resendBulkPendingMessages.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseListPendingMessageResponse>;
    })
  );
}

resendBulkPendingMessages.PATH = '/v1/api/pending-messages/resend-bulk';
